import { useEffect, useState } from "react";

const detectDevice = () => {
  const width = window.innerWidth;
  if (width < 768) {
    return "Mobile";
  } else if (width < 1024) {
    return "Tablet";
  } else {
    return "Desktop";
  }
};

export const useDeviceDetach = (): {
  deviceType: "Mobile" | "Tablet" | "Desktop";
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
} => {
  const [deviceType, setDeviceType] = useState<"Mobile" | "Tablet" | "Desktop">(
    detectDevice()
  );

  useEffect(() => {
    const updateDeviceType = () => {
      setDeviceType(detectDevice());
    };

    window.addEventListener("resize", updateDeviceType);

    return () => {
      window.removeEventListener("resize", updateDeviceType);
    };
  }, []);

  return {
    deviceType,
    isMobile: deviceType === "Mobile",
    isTablet: deviceType === "Tablet",
    isDesktop: deviceType === "Desktop",
  };
};
